/**
 * Shoppable Video → Cart Drawer Fix
 * Nutrify / Wonder Theme
 */

(function () {
  document.addEventListener(
    'click',
    function (e) {
      const quickAddEl = e.target.closest('.shoppable-video__product quick-add');
      if (!quickAddEl) return;

      e.stopImmediatePropagation();
      e.preventDefault();

      const btn = quickAddEl.querySelector('button[data-product-url]');
      if (!btn) return;

      const productUrl = btn.getAttribute('data-product-url');
      if (!productUrl) return;

      btn.disabled = true;

      const productJsonUrl = productUrl.split('?')[0].replace(/\/$/, '') + '.js';

      fetch(productJsonUrl)
        .then((res) => res.json())
        .then((product) => {
          const variant =
            product.variants.find((v) => v.available) || product.variants[0];

          if (!variant) throw new Error('No variant found');

          // Open drawer immediately — don't wait for cart add
          openWonderCartDrawer();

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 }),
          });
        })
        .then((res) => {
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
          return res.json();
        })
        .then(() => {
          btn.disabled = false;
          // Refresh cart contents after item added
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
        })
        .catch((err) => {
          console.error('[ShoppableVideo → CartDrawer]', err);
          btn.disabled = false;
        });
    },
    true
  );

  function openWonderCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const drawerEl = cartDrawer.querySelector('.wt-cart__drawer');
    const activeDrawerClass = 'wt-cart__drawer--open';
    const activeBodyClass = 'page-overlay-cart-on';

    if (drawerEl && !drawerEl.classList.contains(activeDrawerClass)) {
      drawerEl.classList.add(activeDrawerClass);
    }

    cartDrawer.setAttribute('open', '');
    document.body.classList.add(activeBodyClass);
  }
})();